"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TweekClientWithFallback = (function () {
    function TweekClientWithFallback(_clients) {
        this._clients = _clients;
    }
    TweekClientWithFallback.prototype.getValues = function (path, config) {
        return this._execute(function (client) { return client.getValues(path, config); });
    };
    TweekClientWithFallback.prototype.getValuesWithDetails = function (path, config) {
        return this._execute(function (client) { return client.getValuesWithDetails(path, config); });
    };
    TweekClientWithFallback.prototype.fetch = function (path, config) {
        return this._execute(function (client) { return client.fetch(path, config); });
    };
    TweekClientWithFallback.prototype._execute = function (fn) {
        return this._clients.reduce(function (acc, client) { return acc.catch(function () { return fn(client); }); }, Promise.reject(new Error('TweekClientWithFallback has no clients')));
    };
    return TweekClientWithFallback;
}());
exports.default = TweekClientWithFallback;
//# sourceMappingURL=TweekClientWithFallback.js.map